import { createExternalLineMessageStore, LineMessageFormStoreState } from '../../components';

import { LineMessageDialogProps } from './types';

type LineMessageDialogStoreProps = Omit<LineMessageDialogProps, 'initialValues' | 'dialogId'>;

type LineMessageDialogStoreState = LineMessageDialogStoreProps & LineMessageFormStoreState;

export const useLineMessageDialogStore =
  createExternalLineMessageStore<LineMessageDialogStoreProps>();

export const isNewLineMessageDialogSelector = (state: LineMessageDialogStoreState) =>
  state.messageId === undefined;
